<script>
    import IconCircleFull from '@/components/icon/IconCircleFull.vue';
    import constants from '@/constants';

    export default { 
        computed: {
            mainColor() {return this.$store.getters.MAIN_COLOR},
            colors() {return constants.MAIN_COLOR},
        },
        components: {
            IconCircleFull: IconCircleFull,
        },
        methods: {
            async changeColor(colorName) {
                this.$store.commit('MAIN_COLOR', colorName);
                this.$store.dispatch('SAVE_LOCAL_STORAGE');
                this.$store.dispatch('CHANGE_THEME');
            }
        }
    }
</script>


<template>
    <div 
        class="default_color_container cursor_pointer ml_10"
        v-for="(colorValue, colorIndex) in colors" :key="colorIndex"
        @click="changeColor(colorValue['name'])"
    >
        <IconCircleFull 
            iconWidth = "36px"
            iconHeight = "36px"
            class="setting_color"
            :style="`
                --setting-main-color: ${colorValue['color']};
                --setting-main-color-hover: ${colorValue['color_hover']};
            `"
        />

        <div 
            class="color_container select_color mt_10"
            v-if="mainColor === colorValue['name']"
        ></div>
        <div
            class="color_container unselect_color mt_10"
            v-else
        ></div>
    </div>
</template>


<style scoped>
    .default_color_container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .color_container {
        border-radius: 20px;
        width: 36px;
        height: 20px;
    }
    .select_color {
        background-color: var(--main-color);
    }
    .unselect_color {
        background-color: var(--background);
    }
</style>